module.exports = __webpack_public_path__ + "img/email.7bc71a1a.svg";